enum StatusAtendimento {
    Aberto = 0,
    EmAtendimento = 1,
    Fechado = 2,
}

export default StatusAtendimento;
